import React, { Component } from "react";
import { Container,  Button, Modal, Form } from "react-bootstrap";
import Select from 'react-select';
import CreatableSelect from "react-select/creatable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSyncAlt} from "@fortawesome/free-solid-svg-icons";
import PhoneInput, { formatPhoneNumber, formatPhoneNumberIntl, isPossiblePhoneNumber, isValidPhoneNumber } from 'react-phone-number-input';
import 'react-phone-number-input/style.css';


const components = {DropdownIndicator: null};

const createOption = (label) => ({
    label,
    value: label,
  });

  /*
  function toSubscriberId(name, gcid)
  {
      var result = gcid + ":" + name.replace(/\s+/g, '');
      return result.toLowerCase().trim();
  }
    */

  function cleanValue(val)
  {
      return (val) ? val.trim() : "";
  }

  function emailIsValid (email) 
  {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
  }



export default class ModalNewSubscriberDialog extends Component {

    constructor(props) {
        super(props);
        this.state = {
            options: [],
            blockInputValue: '',
            blockValue: [],
            isWorking: false,
            selectedDocs: [],
            subscriberNameErr: "",
            subscriberEmailErr: "",
            subscriberPhoneErr: "",
            subscriberRanchErr: "",
            subscriberDocErr: ""

        }

        this.initDialog = this.initDialog.bind(this);
        this.onFormValueChange = this.onFormValueChange.bind(this);
        this.onDocValueChange = this.onDocValueChange.bind(this);
        this.onPhoneNbrChange = this.onPhoneNbrChange.bind(this);
        this.validateSubscriber = this.validateSubscriber.bind(this);
        this.postNewSubscriber = this.postNewSubscriber.bind(this); 
        this.toNotificationDocValues = this.toNotificationDocValues.bind(this);
    }

    componentDidUpdate(prevProps, prevState)
    {
        if (prevProps.showNewSubscriberModal !== this.props.showNewSubscriberModal)
        {
            if (this.props.showNewSubscriberModal)
            {
                this.initDialog();
            }
        }
    }

    initDialog()
    {
        // clear out state values
        this.setState({
            subscriberNameErr: "",
            subscriberEmailErr: "",
            subscriberPhoneErr: "",
            subscriberRanchErr: "",
            subscriberDocErr: ""
        });
        if (this.props.editMode === "add")
        {
            this.setState({
                isWorking: false,
                subscriberName: "",
                subscriberCompany: "",
                subscriberPhone: "",
                subscriberPosition: "",
                subscriberEmail: "",
                subscriberComments: "",
                blockInputValue: '',
                blockValue: [],
                selectedDocs: []
            });
        }
        else
        {
            // update. Set the values
            this.setState(
                {
                    subscriberName: this.props.currentSubscriber.name,
                    subscriberCompany: this.props.currentSubscriber.company,
                    subscriberPhone: this.props.currentSubscriber.phone,
                    subscriberPosition: this.props.currentSubscriber.position,
                    subscriberEmail: this.props.currentSubscriber.email,
                    subscriberComments: this.props.currentSubscriber.comments,
                    blockValue: Array.isArray(this.props.currentSubscriber.ranches) ? this.props.currentSubscriber.ranches.map(x => {return {"value": x, "label": x}}): [],   
                    selectedDocs: Array.isArray(this.props.currentSubscriber.documents) ? this.toNotificationDocValues(): []
                }
            );
        }


    }

    onFormValueChange(e)
    {
        this.setState({ [e.target.id]: e.target.value })
    }

    onPhoneNbrChange(val)
    {
        this.setState({subscriberPhone: val});
    }

    onDocValueChange(opts)
    {
        //var newOpts = (Array.isArray(opts) ? opts.map(x => x.value) : []);
        this.setState({selectedDocs: opts})
    }



    validateSubscriber(subscriber)
    {
        var subscriberNameErr = (subscriber.name === "") ? "*You must enter a Name" : "";
        subscriberNameErr = (subscriber.name !== "" && subscriber.name.length<6) ? "* Your name must be at least 6 characters" : subscriberNameErr;
        var subscriberRanchErr = (subscriber.ranches.length < 1) ? "*You must enter at least one block" : "";
        var subscriberDocErr = (subscriber.documents.length < 1) ? "*You must select at least one document" : "";
        var subscriberEmailErr = "";
        var subscriberPhoneErr = "";
        for(var i=0; i<subscriber.documents.length; i++)
        {
           var fullDoc = this.props.notificationDocs.filter(doc => doc.id === subscriber.documents[i])[0];
           if ((fullDoc.transportType.toLowerCase()==="email") && (subscriber.email.trim() === ""))
           {
                subscriberEmailErr = "*The document(s) you selected require an email address";
           }
           if ((fullDoc.transportType.toLowerCase()==="text") && (subscriber.phone.trim() === ""))
           {
                subscriberPhoneErr = "*The document(s) you selected require an phone number";
           }
       } 
       if (subscriber.phone.trim() !== "")
       {
           if (!isPossiblePhoneNumber(subscriber.phone.trim()))
           {
               subscriberPhoneErr = "*This appears to be an invalid phone number";
           }
       }
       if (subscriber.email.trim() !== "")
       {
           if (!emailIsValid(subscriber.email.trim()))
            {
                subscriberEmailErr = "*This appears to be an invalid email address";
            }    
       }

       this.setState(
           {
               subscriberNameErr: subscriberNameErr,
               subscriberRanchErr: subscriberRanchErr,
               subscriberDocErr: subscriberDocErr,
               subscriberEmailErr: subscriberEmailErr,
               subscriberPhoneErr: subscriberPhoneErr
           }
       )

       return ((subscriberNameErr === "") && (subscriberRanchErr === "") && (subscriberDocErr === "") 
        && (subscriberEmailErr === "") && (subscriberPhoneErr === ""));
    }



    async postNewSubscriber()
    {
        this.setState({isWorking: true});
        // validate
        var gcid = (this.props.userSession) ? this.props.userSession.gcid : "";
        var name = cleanValue(this.state.subscriberName);
        var formattedPhoneNbr = cleanValue(this.state.subscriberPhone); //this.cleanPhoneNbr(this.state.subscriberPhone);
        var subscriber = {
            "id": (this.props.editMode === "add") ? "": this.props.currentSubscriber.id, // new
            "gcid": gcid, 
            "name": name, 
            "company": cleanValue(this.state.subscriberCompany), 
            "position": cleanValue(this.state.subscriberPosition), 
            "email": cleanValue(this.state.subscriberEmail), 
            "phone": formattedPhoneNbr, 
            "comments": cleanValue(this.state.subscriberComments),
            "ranches": (Array.isArray(this.state.blockValue) ? this.state.blockValue.map(x => x.value) : []), 
            "documents": (Array.isArray(this.state.selectedDocs) ? this.state.selectedDocs.map(d => d.value) : []), 
        };
        if (!this.validateSubscriber(subscriber))
        {
            this.setState({isWorking: false});
            return;
        }

        var postResult = (this.props.editMode === "add")  ? 
            await this.props.postNewSubscriber(subscriber) 
            : await this.props.postUpdatedSubscriber(subscriber);

        this.setState({isWorking: false});
    }

    toNotificationDocValues()
    {
        var filteredDocs = this.props.notificationDocs.filter(nd => this.props.currentSubscriber.documents.indexOf(nd.id) >=0);
        return filteredDocs.map(d => 
            {
                return {"value": d.id, "label": d.description}
            }
        );
    }

    toNotificationDocOptions()
    {
        console.log("Notification Docs:");
        console.info(this.props.notificationDocs);
        var notificationDocOptions = this.props.notificationDocs.map(nd => {
            return {"value": nd.id, "label": nd.description}
        });
        return notificationDocOptions;
    }

    handleBlockChange = (blockValue,actionMeta) => 
    {
        console.group('Value Changed');
        console.log(blockValue);
        console.log(`action: ${actionMeta.action}`);
        console.groupEnd();
        this.setState({ blockValue });
      };
      handleBlockInputChange = (blockInputValue) => {
        this.setState({ blockInputValue });
      };
      handleBlockKeyDown = (event) => {
        const { blockInputValue, blockValue } = this.state;
        if (!blockInputValue) return;
        // eslint-disable-next-line default-case
        switch (event.key) {
          
          case 'Enter':
          case 'Tab':
            console.group('Value Added');
            console.log(blockValue);
            console.groupEnd();
            this.setState({
              blockInputValue: '',
              blockValue: [...blockValue, createOption(blockInputValue)],
            });
            event.preventDefault();
        }
      };


    render() {
        var docOptions = (this.props.notificationDocs) ? 
            this.toNotificationDocOptions(this.props.notificationDocOptions) : 
            [{"value": "", "label": "Loading..."}];

            const workingButtonIcon = this.state.isWorking ? (
                <FontAwesomeIcon icon={faSyncAlt} color="green" spin />
              ) : (
                "Ok"
              );

        const {blockInputValue, blockValue } = this.state;

        return (
            <Modal
                show={this.props.showNewSubscriberModal}
                onHide={this.props.closeNewSubscriberModal}
            >
                <Modal.Header closeButton>
                    <Modal.Title>New Subscriber Entry/Edit</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container>
                        <Form>
                            <Form.Group className="mb-3">
                                <Form.Text className="text-muted">
                                     name of new subscriber&nbsp;<span style={{color: "red"}} >{this.state.subscriberNameErr}</span>
                                </Form.Text>
                                <Form.Control id="subscriberName" type="text" placeholder="Name" value={this.state.subscriberName} onChange={(e) => this.onFormValueChange(e)}/>
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Text className="text-muted">
                                     company
                                </Form.Text>
                                <Form.Control id="subscriberCompany" type="text" placeholder="Company"  value={this.state.subscriberCompany} onChange={(e) => this.onFormValueChange(e)}/>
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Text className="text-muted">
                                    position
                                </Form.Text>
                                <Form.Control id="subscriberPosition" type="text" placeholder="Position" value={this.state.subscriberPosition}  onChange={(e) => this.onFormValueChange(e)}/>
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Text className="text-muted">
                                    email&nbsp;<span style={{color: "red"}}>{this.state.subscriberEmailErr}</span>
                                </Form.Text>
                                <Form.Control id="subscriberEmail" type="email" placeholder="Email" value={this.state.subscriberEmail}  onChange={(e) => this.onFormValueChange(e)}/>
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Text className="text-muted">
                                    phone number&nbsp;<span style={{color: "red"}}>{this.state.subscriberPhoneErr}</span>
                                </Form.Text>
                                <PhoneInput
                                    defaultCountry="US"
                                    placeholder="phone number"
                                    value={this.state.subscriberPhone}
                                    onChange={this.onPhoneNbrChange}
                                />
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Text className="text-muted">
                                    blocks&nbsp;<span style={{color: "red"}}>{this.state.subscriberRanchErr}</span>
                                </Form.Text>
                            <CreatableSelect
                                components={components}
                                inputValue={blockInputValue}
                                isClearable
                                isMulti
                                menuIsOpen={false}
                                onChange={this.handleBlockChange}
                                onInputChange={this.handleBlockInputChange}
                                onKeyDown={this.handleBlockKeyDown}
                                placeholder="Type in a Block and press enter..."
                                value={blockValue}
                />
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Text className="text-muted">
                                    documents&nbsp;<span style={{color: "red"}}>{this.state.subscriberDocErr}</span>
                                </Form.Text>
                                <Select
                                    autoFocus
                                    placeholder={"Select Notification Docs"}
                                    options={docOptions}
                                    onChange={opts => this.onDocValueChange(opts)}
                                    isSearchable={true}
                                    isMulti={true}
                                    value={this.state.selectedDocs}
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Text className="text-muted">
                                    comments
                                </Form.Text>
                                <Form.Control id="subscriberComments" type="text" placeholder="Comments" value={this.state.subscriberComments}  onChange={(e) => this.onFormValueChange(e)}/>
                            </Form.Group>
                        </Form>
                    </Container>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="secondary"
                        disabled={this.state.isWorking}
                        onClick={(e) => this.postNewSubscriber(e)}
                    >
                        {workingButtonIcon}
                    </Button>
                    <Button
                        variant="secondary"
                        disabled={this.state.isWorking}
                        onClick={this.props.closeNewSubscriberModal}
                    >
                        Cancel
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}
